module.exports = __webpack_public_path__ + "static/media/HalfStar.06384637.svg";